// extracted by mini-css-extract-plugin
module.exports = {"body":"body--2wisp"};